module.exports = __webpack_public_path__ + "static/media/SBI.99120531.svg";